const categories = {
    fish: 'fish',
    object: 'object',
    tea: 'tea',
    tree: 'tree',
    wc: 'wc',

}

export const items = [
    {
        id: "18",
        category: {
            key: "fish",
            name: "Водоём"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Тройной водопад 三位一体の滝",
        coords: [13.041237113402, 20.094191522763],
        mapsCoords: ['45.044471484136125', '39.035601322029606'],
        description: `Тематический японский ресторан, расположенный на берегу озера Ойке. Интерьер ресторана оформлен в стиле сёин-дзукури («кабинетный стиль»).<br>
        <br>
        Фасад здания украшают панорамные витражные окна с видом на мост Шиабаши, озеро Ойке и храм Мидо. Живописный пейзаж из цветущих кустарников и деревьев окружает Рётэй со всех сторон.<br>
       <a href="http://www.ryotei.ru">www.ryotei.ru</a><br>
        <br>
       Забронировать стол: +7-938-508-88-77`
    },
    {
        id: "19",
        category: {
            key: "tree",
            name: "Сад / Лес"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Сад с топиариями 刈り込みの庭",
        coords: [39.639175257732, 18.053375196232],
        mapsCoords: [45.04451002340939, 39.0368295687008]
    },
    {
        id: "20",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Пагода Тахото 多宝塔",
        coords: [51.752577319588, 11.773940345369],
        mapsCoords: [45.044652136753555, 39.03739017921464]
    },
    {
        id: "21",
        category: {
            key: "fish",
            name: "Водоём"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Большой водопад Отаки 大滝",
        coords: [59.639175257732, 11.616954474097],
        mapsCoords: [45.04465695414884, 39.03776052191769]
    },
    {
        id: "22",
        category: {
            key: "wc",
            name: "Туалет"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Туалет お手洗い",
        coords: [86.546391752577, 8.1632653061224],
        mapsCoords: [45.04473162372328, 39.039000660327076]
    },
    {
        id: "23",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Садовые коридоры Цубо-нива кайро 坪庭回廊",
        coords: [80.670103092784, 23.547880690738],
        mapsCoords: [45.044394405511234, 39.038728849168834]
    },
    {
        id: "24",
        category: {
            key: "fish",
            name: "Водоём"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Пруд с мостом Яцухаси 八ッ橋の池",
        coords: [73.762886597938, 35.949764521193],
        mapsCoords: [45.044119812060394, 39.038412868697414]
    },
    {
        id: "25",
        category: {
            key: "fish",
            name: "Водоём"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Зеркальный пруд Кагамиикэ 鏡池",
        coords: [54.896907216495, 36.106750392465],
        mapsCoords: [45.04411499461957, 39.03753967535166]
    },
    {
        id: "26",
        category: {
            key: "tea",
            name: "Общепит"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Кофейня Киссатэн 喫茶 大",
        coords: [41.80412371134, 30.926216640502],
        mapsCoords: [45.044225795654796, 39.036938293164084]
    },
    {
        id: "27",
        category: {
            key: "tea",
            name: "Общепит"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Ресторан Рётэй 料亭",
        coords: [20.515463917526, 40.175863447206],
        mapsCoords: [45.04402828061524, 39.035946182436604]
    },
    {
        id: "29",
        category: {
            key: "tea",
            name: "Общепит"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Чайный домик  喫茶室",
        coords: [39.5, 51],
        mapsCoords: [45.043787407686686, 39.03682277342186]
    },
    {
        id: "30",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Павильон, где начинается поток  流れが始まる四阿",
        coords: [66.649484536082, 44.270015698587],
        mapsCoords: [45.043934340294555, 39.038079900028634]
    },
    {
        id: "31",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Театр Но 能楽堂",
        coords: [86.443298969072, 38.932496075353],
        mapsCoords: [45.04404995912872, 39.0389972626876]
    },
    {
        id: "32",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Храм на опорах Какэдзукури-но-Мидо 懸造りの御堂",
        coords: [11.59793814433, 66.248037676609],
        mapsCoords: [45.04345259262007, 39.035535068059815]
    },
    {
        id: "33",
        category: {
            key: "fish",
            name: "Водоём"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Большое озеро Оикэ  大池",
        coords: [26.701030927835, 55.223003315073],
        mapsCoords: [45.0436934669678, 39.03623158415273]
    },
    {
        id: "34",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Старинный народный дом Коминка  古民家",
        coords: [73.659793814433, 59.737145275433],
        mapsCoords: [45.04359711735124, 39.038402675779]
    },
    {
        id: "35",
        category: {
            key: "tree",
            name: "Сад / Лес"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Сливовая роща Умэбаяси 梅林",
        coords: [7.9896907216495, 87.598116169545],
        mapsCoords: [45.04298047593682, 39.035368583725386]
    },
    {
        id: "36",
        category: {
            key: "wc",
            name: "Туалет"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Туалет お手洗い",
        coords: [17.5, 75],
        mapsCoords: [45.04325748364998, 39.03580687921803]
    },
    {
        id: "37",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Павильон Адзумая 四阿",
        coords: [23, 88],
        mapsCoords: [45.04297324963059, 39.036061702178856]
    },
    {
        id: "38",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Сухой пруд Карэикэ 枯れ池",
        coords: [41, 77],
        mapsCoords: [45.043214126010085, 39.036897521490346]
    },
    {
        id: "39",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Центральный вход и Ворота Карамон 中央口エリアと唐門",
        coords: [46.443298969072, 88.069073783359],
        mapsCoords: [45.042968432092586, 39.037142151532755]
    },
    {
        id: "40",
        category: {
            key: "tree",
            name: "Сад / Лес"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Сухой ландшафтный сад Карэсансуй 枯山水庭園",
        coords: [48, 76],
        mapsCoords: [45.04323580483417, 39.037220297240765]
    },
    {
        id: "41",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Храм Дзадзэн-до и Сад Дзэн 座禅堂 と 禅の庭",
        coords: [56.546391752577, 79.905808477237],
        mapsCoords: [45.04314908948826, 39.03761442342014]
    },
    {
        id: "42",
        category: {
            key: "object",
            name: "Объекты"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Ворота Сукиямон 数寄屋門",
        coords: [61.030927835052, 91.185667599276],
        mapsCoords: [45.042898577745625, 39.03781488414934]
    },
    {
        id: "43",
        category: {
            key: "tree",
            name: "Сад / Лес"
        },
        img: "https://sun2-17.userapi.com/impg/ZFTi6lGaA_1WW3o7YTysawIsc4GyrGuWuQfRmA/EBNtmbi3lNc.jpg?size=532x800&quality=95&sign=20a4b0b1a2a350c11d865ebed18e1783&type=album",
        title: "Бамбуковая роща 竹林の庭",
        coords: [66.649484536082, 74.7842851433],
        mapsCoords: [45.04326230116347, 39.038073104749635]
    }
]
